import { IContact } from '../../../contact_interfaces';
import { ContactsService } from '../../../services/contact_service';

export class ContactCardController {
  private contact: IContact;

  constructor(private ngContactsService: ContactsService, private $state: ng.ui.IStateService) {}

  get initials(): string {
    return this.ngContactsService.createInitials(this.contact);
  }

  goToContactsDetail(): void {
    this.$state.go('my.contactDetail', {
      contactId: this.contact.id,
      relationship: this.contact.relationship
    });
  }
}

export class ContactCardComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-resources/src/components/people/contact_card/contact_card.html';
  public controller: any = ContactCardController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    contact: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/components/people/contact_card/contact_card.ts